var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"returntap"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"returntap",attrs:{"src":"http://bernouly.oss-cn-beijing.aliyuncs.com/images/active/active2.png","alt":""},on:{"click":_vm.returnTop}})])
}
var staticRenderFns = []

export { render, staticRenderFns }